import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup } from '@zillow/constellation-10';

export default class InquiryInAction extends React.Component {
  static propTypes = {
    onSelectAction: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleOnClickCall = this.handleOnClick.bind(this, 'call');
    this.handleOnClickSMS = this.handleOnClick.bind(this, 'sms');
  }

  handleOnClick(action) {
    const { onSelectAction } = this.props;

    onSelectAction(action);
  }

  render() {
    return (
      <ButtonGroup aria-label="contact controls">
        <Button tone="brand" emphasis="outlined" onClick={this.handleOnClickCall}>
          Call
        </Button>
        <Button tone="brand" emphasis="outlined" onClick={this.handleOnClickSMS}>
          SMS
        </Button>
      </ButtonGroup>
    );
  }
}
